import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ICloneTypesState } from "./slice";
import { getCloneTypesAsync } from "./actions";

type Reducer = (builder: ActionReducerMapBuilder<ICloneTypesState>) => void;

export const getCloneTypesReducer: Reducer = (builder) => {
  builder.addCase(getCloneTypesAsync.pending, (state) => {
    state.cloneTypes.isLoading = true;
  });

  builder.addCase(getCloneTypesAsync.fulfilled, (state, actions) => {
    state.cloneTypes.isLoading = false;
    state.cloneTypes.items = actions.payload;
  });

  builder.addCase(getCloneTypesAsync.rejected, (state) => {
    state.cloneTypes.isLoading = false;
    state.cloneTypes.items = [];
  });
};
